// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Impreso_container__MsGfj {
  animation: Impreso_init__TnXyq 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  font-size: 16px;
}

/*---Title---*/
.Impreso_container__MsGfj .Impreso_titleContainer__TbjpH {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Impreso_container__MsGfj .Impreso_titleContainer__TbjpH h4 {
  width: 95%;
  text-align: center;
  font-size: 2rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Impreso_container__MsGfj .Impreso_titleContainer__TbjpH .Impreso_arrow__P0wLb {
  transition: 0.3s;
}

.Impreso_container__MsGfj .Impreso_titleContainer__TbjpH .Impreso_arrow__P0wLb:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.Impreso_container__MsGfj .Impreso_loader__\\+VFqr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 500px;
}

.Impreso_container__MsGfj .Impreso_loader__\\+VFqr p {
  font-size: 24px;
  font-weight: 300;
}

.Impreso_container__MsGfj .Impreso_buttons__ln-LI {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.Impreso_container__MsGfj .Impreso_forPrint__dbpBf {
  display: none;
  width: 100%;
  scale: 0.9;
}

@keyframes Impreso_init__TnXyq {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media print {
  .Impreso_container__MsGfj .Impreso_forPrint__dbpBf {
    display: initial;
  }
  @page {
    size: portrait;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Impreso/Impreso.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  font-size: 16px;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .titleContainer h4 {\n  width: 95%;\n  text-align: center;\n  font-size: 2rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .titleContainer .arrow {\n  transition: 0.3s;\n}\n\n.container .titleContainer .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container .loader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 500px;\n}\n\n.container .loader p {\n  font-size: 24px;\n  font-weight: 300;\n}\n\n.container .buttons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.container .forPrint {\n  display: none;\n  width: 100%;\n  scale: 0.9;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@media print {\n  .container .forPrint {\n    display: initial;\n  }\n  @page {\n    size: portrait;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Impreso_container__MsGfj`,
	"init": `Impreso_init__TnXyq`,
	"titleContainer": `Impreso_titleContainer__TbjpH`,
	"arrow": `Impreso_arrow__P0wLb`,
	"loader": `Impreso_loader__+VFqr`,
	"buttons": `Impreso_buttons__ln-LI`,
	"forPrint": `Impreso_forPrint__dbpBf`
};
export default ___CSS_LOADER_EXPORT___;
